<template>
  <div id="app">
    <Viewer />
  </div>
</template>

<script>
import Viewer from '@/components/360Viewer'
export default {
  name: 'App',
  components: {
    Viewer,
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

#app {
  width: inherit;
  height: inherit;
}
</style>
